import { AccountStatusAlert, UserStatusEnum, useUser } from '@acme/domains';
import { ProfileEditPage } from '@pages/profile';

export const ProfilePage = () => {
  const { user } = useUser();
  const isConfirmed = user?.status === UserStatusEnum.Confirmed;

  return (
    <div className="flex flex-col gap-6">
      <div
        className={`flex  ${
          isConfirmed ? 'flex-row justify-between' : 'flex-col'
        }`}
      >
        <h1 className="flex-1 text-2xl font-bold">Профиль</h1>
        {isConfirmed && (
          <AccountStatusAlert
            status={user?.status}
            date={user?.currentStatusStartAt}
          />
        )}
      </div>

      {!isConfirmed && (
        <AccountStatusAlert
          status={user?.status}
          date={user?.currentStatusStartAt}
        />
      )}
      <ProfileEditPage />
    </div>
  );
};
